import Image from 'app/Components/Shared/Image/image';
import React from 'react';
import './ErrorStage.scss';
import alertIcon from '../../Images/alert.svg';
import FuntoneButton from '../../../../Components/FuntoneButton/FuntoneButton';

export default function ErrorStageUI({error, onClose, onRetry}) {
  return (
    <div className='error-stage-wrapper'>
      <div className='top-content'>
        <Image src={alertIcon} className='alert-icon' aria-hidden />
        <div className='alert-message'>
          משהו לא עבד,
          <br /> שננסה שוב?
        </div>
      </div>
      <FuntoneButton text='זיהוי מחדש' variant='primary' onClick={onRetry} />
    </div>
  );
}
